import { filter } from "@msuite/utils/array";
import { useMemo } from "react";

interface UseFilter<T> {
	filtered: T[];
	original: T[] | undefined;
}

/**
 * This hook is a shorthand for filtering an array of objects based on a search value.
 * @param original
 * @param searchValue
 * @returns {T[]} The filtered array
 */
export function useFilter<T>(original: T[] | undefined, searchValue: string | null): UseFilter<T> {
	/** Filtering */
	const filtered = useMemo(() => {
		if (!original) return [];
		if (!searchValue) return original || [];
		return filter(original, searchValue);
	}, [original, searchValue]);

	return { filtered, original };
}
